(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bundle-picker"] && !Shopify.designMode) return;
  try {
    (() => {
    const picker = document.querySelector('[data-bundle-picker]');
    if (!picker) return;

    document.body.setAttribute('data-bundle-picker-active', '');

    const bundleRadios = picker.querySelectorAll('input[type="radio"][name="kleckerli-bundle"]');
    const slotsContainer = picker.querySelector('[data-bundle-slots]');

    const getSelectedBundleSize = () => {
      const checked = picker.querySelector('input[name="kleckerli-bundle"]:checked');
      return checked ? parseInt(checked.value, 10) || 1 : 1;
    };

    const updateSlotVisibility = () => {
      const size = getSelectedBundleSize();
      slotsContainer.querySelectorAll('.bundle-picker__slot').forEach((slot) => {
        const idx = parseInt(slot.getAttribute('data-slot-index'), 10);
        if (idx <= size) {
          slot.removeAttribute('hidden');
        } else {
          slot.setAttribute('hidden', '');
        }
      });

      const firstLabel = slotsContainer.querySelector('.bundle-picker__slot[data-slot-index="1"] .bundle-picker__slot-label');
      if (firstLabel) {
        firstLabel.textContent = size === 1 ? 'Wähle deine Farbe' : 'Set 1';
      }
    };

    const collectSelectedVariants = () => {
      const size = getSelectedBundleSize();
      const variantIds = [];
      for (let i = 1; i <= size; i++) {
        const input = picker.querySelector(`input[name="kleckerli-slot-${i}"]:checked`);
        if (input && input.value) {
          variantIds.push(parseInt(input.value, 10));
        }
      }
      return variantIds;
    };

    const findMainATC = () => {
      const scope = document.querySelector('product-info');
      if (!scope) return null;
      return scope.querySelector('product-form form [name="add"]') || scope.querySelector('form[action$="/cart/add"] [name="add"]');
    };

    const setBusy = (busy) => {
      const btn = findMainATC();
      if (!btn) return;
      btn.classList.toggle('loading', busy);
      btn.disabled = busy;
      const spinner = btn.querySelector('.loading__spinner');
      if (spinner) spinner.classList.toggle('hidden', !busy);
    };

    const refreshCartDrawer = (response) => {
      const drawer = document.querySelector('cart-drawer');
      if (!drawer) return;

      // This theme places the `is-empty` class on the outer <cart-drawer> element
      // instead of `.drawer__inner` (where vanilla Dawn puts it). Dawn's renderContents()
      // only clears it from .drawer__inner, so the outer class persists after the AJAX
      // add and CSS keeps the cart visually collapsed (no header, items area squished).
      // Strip it manually so the cart drawer renders correctly post-add.
      drawer.classList.remove('is-empty');

      if (response && response.sections && typeof drawer.renderContents === 'function') {
        try {
          drawer.renderContents(response);
        } catch (e) {
          if (typeof drawer.open === 'function') drawer.open();
        }
      } else if (typeof drawer.open === 'function') {
        drawer.open();
      } else {
        drawer.classList.add('animate', 'active');
        document.body.classList.add('overflow-hidden');
      }
    };

    const publishCartUpdate = (response) => {
      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
        try {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: 'bundle-picker',
            cartData: response
          });
        } catch (e) { /* noop */ }
      }
    };

    const showError = (message) => {
      let el = picker.querySelector('[data-bundle-error]');
      if (!el) {
        el = document.createElement('div');
        el.setAttribute('data-bundle-error', '');
        el.style.cssText = 'margin-top:1rem;padding:0.8rem 1rem;border-radius:8px;background:rgba(220,53,69,0.08);color:#b3261e;font-size:1.4rem;line-height:1.4;';
        picker.appendChild(el);
      }
      el.textContent = message;
    };

    const clearError = () => {
      const el = picker.querySelector('[data-bundle-error]');
      if (el) el.remove();
    };

    const addBundleToCart = async () => {
      clearError();
      const variantIds = collectSelectedVariants();
      if (variantIds.length === 0) {
        showError('Bitte wähle mindestens eine Farbe aus.');
        return;
      }

      const counts = {};
      variantIds.forEach((id) => { counts[id] = (counts[id] || 0) + 1; });
      const items = Object.entries(counts).map(([id, qty]) => ({ id: parseInt(id, 10), quantity: qty }));

      const cartAddUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
      const fetchUrl = cartAddUrl.endsWith('.js') ? cartAddUrl : cartAddUrl + '.js';
      const drawer = document.querySelector('cart-drawer');
      const sectionIds = drawer && typeof drawer.getSectionsToRender === 'function'
        ? drawer.getSectionsToRender().map((s) => s.id).join(',')
        : 'cart-drawer,cart-icon-bubble';

      setBusy(true);
      try {
        const response = await fetch(fetchUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify({ items, sections: sectionIds, sections_url: window.location.pathname })
        });

        const data = await response.json();

        if (!response.ok || data.status) {
          showError(data.description || data.message || 'Hinzufügen fehlgeschlagen. Bitte versuche es erneut.');
          return;
        }

        publishCartUpdate(data);
        refreshCartDrawer(data);
      } catch (err) {
        showError('Verbindungsfehler. Bitte prüfe deine Internetverbindung.');
      } finally {
        setBusy(false);
      }
    };

    bundleRadios.forEach((radio) => {
      radio.addEventListener('change', () => {
        if (radio.checked) updateSlotVisibility();
      });
    });

    // Sync slot 1's color selection to the main (hidden) variant picker.
    // Triggering the standard picker's input change fires Dawn's variant-change logic
    // (gallery swap, URL update, price refresh, hidden form id input update).
    const syncMainPicker = (variantName) => {
      if (!variantName) return;
      const productInfo = document.querySelector('product-info');
      if (!productInfo) return;

      // Collect all candidate inputs/options across the supported picker types,
      // then match by value strictly equal to variantName. Avoids querySelector
      // attribute-selector quirks with non-ASCII chars (é in "Rosé").
      const inputs = productInfo.querySelectorAll(
        'variant-radios input[type="radio"], ' +
        'fieldset.product-form__input--swatch input[type="radio"], ' +
        'fieldset.product-form__input--pill input[type="radio"]'
      );
      let target = null;
      for (const input of inputs) {
        if (input.value === variantName) {
          target = input;
          break;
        }
      }

      if (!target) {
        // Fall back to dropdowns
        const selects = productInfo.querySelectorAll('variant-selects select, select.product-form__input');
        for (const select of selects) {
          for (const option of select.options) {
            if (option.value === variantName) {
              if (select.value !== option.value) {
                select.value = option.value;
                select.dispatchEvent(new Event('change', { bubbles: true }));
              }
              return;
            }
          }
        }
        return;
      }

      if (!target.checked) {
        target.checked = true;
        target.dispatchEvent(new Event('change', { bubbles: true }));
        target.dispatchEvent(new Event('input', { bubbles: true }));
      }
    };

    // Any slot change drives the main gallery — the last slot the customer
    // interacts with becomes the visible variant. This gives immediate visual
    // feedback when configuring a multi-set bundle. When the bundle quantity
    // changes (1 → 2 → 3), we re-sync to slot 1 so newly visible slots don't
    // hijack the gallery before the user has touched them.
    const onSlotChange = (e) => {
      const target = e.target;
      if (!target || !target.matches) return;
      if (!target.matches('input[name^="kleckerli-slot-"]:checked')) return;
      syncMainPicker(target.dataset.variantName);
    };

    slotsContainer.addEventListener('change', onSlotChange);

    // Re-sync to slot 1 when bundle quantity changes (so resizing the bundle
    // doesn't leave the gallery on a slot that just became visible/hidden).
    bundleRadios.forEach((radio) => {
      radio.addEventListener('change', () => {
        if (!radio.checked) return;
        const slot1 = picker.querySelector('input[name="kleckerli-slot-1"]:checked');
        if (slot1) syncMainPicker(slot1.dataset.variantName);
      });
    });

    // On initial load: if slot 1 has a checked default, sync it once so the
    // page state matches what the user sees.
    const initialSlot1 = picker.querySelector('input[name="kleckerli-slot-1"]:checked');
    if (initialSlot1) {
      syncMainPicker(initialSlot1.dataset.variantName);
    }

    const interceptATC = () => {
      const btn = findMainATC();
      if (!btn || btn.dataset.bundleIntercepted) return;
      btn.dataset.bundleIntercepted = '1';

      const handler = (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        addBundleToCart();
      };

      btn.addEventListener('click', handler, true);

      const form = btn.closest('form');
      if (form && !form.dataset.bundleIntercepted) {
        form.dataset.bundleIntercepted = '1';
        form.addEventListener('submit', (e) => {
          e.preventDefault();
          e.stopImmediatePropagation();
          addBundleToCart();
        }, true);
      }
    };

    interceptATC();

    const reattachObserver = new MutationObserver(() => interceptATC());
    const productInfo = document.querySelector('product-info');
    if (productInfo) {
      reattachObserver.observe(productInfo, { childList: true, subtree: true });
    }

    updateSlotVisibility();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    (() => {
    const bar = document.querySelector('[data-sticky-atc]');
    if (!bar) return;

    const reveal = () => {
      bar.removeAttribute('hidden');
      bar.setAttribute('aria-hidden', 'false');
    };

    const setVisible = (visible) => {
      bar.dataset.visible = visible ? 'true' : 'false';
    };

    const getMainScope = () => document.querySelector('product-info');

    const findTrigger = () => {
      const scope = getMainScope();
      const root = scope || document;
      return (
        root.querySelector('product-form form [name="add"]') ||
        root.querySelector('form[action$="/cart/add"] [name="add"]')
      );
    };

    if (!findTrigger()) return;

    reveal();

    const button = bar.querySelector('[data-sticky-atc-button]');
    const priceEl = bar.querySelector('.sticky-atc__current');
    const compareEl = bar.querySelector('.sticky-atc__compare');

    const scopeQuery = (selector) => {
      const scope = getMainScope();
      if (scope) {
        const found = scope.querySelector(selector);
        if (found) return found;
      }
      return document.querySelector(selector);
    };

    let observer = null;
    let observedTrigger = null;
    const ensureObserver = () => {
      const trigger = findTrigger();
      if (!trigger) return;
      if (trigger === observedTrigger && observer) return;
      if (observer) observer.disconnect();
      observedTrigger = trigger;
      observer = new IntersectionObserver(
        (entries) => entries.forEach((entry) => setVisible(!entry.isIntersecting)),
        { rootMargin: '0px 0px -10% 0px', threshold: 0 }
      );
      observer.observe(trigger);
    };
    ensureObserver();

    const syncFromMain = () => {
      const trigger = findTrigger();
      if (!trigger) return;
      ensureObserver();
      const mainSale = scopeQuery('.price__sale .price-item--sale');
      const mainRegular =
        scopeQuery('.price__regular .price-item--regular') ||
        scopeQuery('.price__container .price-item--regular');
      const mainCompare = scopeQuery('.price__sale s.price-item--regular');
      if (button) {
        button.disabled = !!trigger.disabled;
        button.textContent = trigger.disabled ? 'Ausverkauft' : 'In den Warenkorb';
      }
      if (priceEl) {
        const sourcePrice = mainSale || mainRegular;
        if (sourcePrice && sourcePrice.textContent.trim()) {
          priceEl.textContent = sourcePrice.textContent.trim();
        }
      }
      if (compareEl) {
        const t = mainCompare ? mainCompare.textContent.trim() : '';
        compareEl.textContent = t;
        compareEl.style.display = t ? '' : 'none';
      }
    };

    const scheduleSync = () => {
      [80, 250, 600, 1200, 2000].forEach((delay) => setTimeout(syncFromMain, delay));
    };

    document.addEventListener('change', (event) => {
      const target = event.target;
      if (!target || !target.matches) return;
      const scope = getMainScope();
      if (scope && !scope.contains(target)) return;
      if (
        target.matches(
          'variant-radios input, variant-selects select, fieldset[name="Color"] input, fieldset[name="Farbe"] input, input[name^="options"], select[name^="options"]'
        )
      ) {
        scheduleSync();
      }
    });

    if (button) {
      button.addEventListener('click', () => {
        if (button.disabled) return;
        const trigger = findTrigger();
        const form = trigger ? trigger.closest('form') : null;
        if (!form) return;
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.submit();
        }
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
